export const SUPPLIER_CATEGORY_LIST_ALL_ACTION = "SUPPLIER_CATEGORY_LIST_ALL_ACTION";
export const SUPPLIER_CATEGORY_LIST_ALL_SUCCESS = "SUPPLIER_CATEGORY_LIST_ALL_SUCCESS";

export const SUPPLIER_CATEGORY_LIST_ACTION = "SUPPLIER_CATEGORY_LIST_ACTION";
export const SUPPLIER_CATEGORY_LIST_SUCCESS = "SUPPLIER_CATEGORY_LIST_SUCCESS";

export const SUPPLIER_CATEGORY_GET_DETAIL_ACTION = "SUPPLIER_CATEGORY_GET_DETAIL_ACTION";
export const SUPPLIER_CATEGORY_GET_DETAIL_SUCCESS = "SUPPLIER_CATEGORY_GET_DETAIL_SUCCESS";

export const SUPPLIER_CATEGORY_CREATE_ACTION = "SUPPLIER_CATEGORY_CREATE_ACTION";
export const SUPPLIER_CATEGORY_CREATE_SUCCESS = "SUPPLIER_CATEGORY_CREATE_SUCCESS";

export const SUPPLIER_CATEGORY_UPDATE_ACTION = "SUPPLIER_CATEGORY_UPDATE_ACTION";
export const SUPPLIER_CATEGORY_UPDATE_SUCCESS = "SUPPLIER_CATEGORY_UPDATE_SUCCESS";

export const SUPPLIER_CATEGORY_DELETE_ACTION = "SUPPLIER_CATEGORY_DELETE_ACTION";
export const SUPPLIER_CATEGORY_DELETE_SUCCESS = "SUPPLIER_CATEGORY_DELETE_SUCCESS";

export const SUPPLIER_CATEGORY_FAIL = "SUPPLIER_CATEGORY_FAIL";